<header class="header fixed-top">
  <div
    class="container-fluid d-flex justify-content-between align-items-center content">
    <!-- Immagine in alto a sinistra -->
    <a routerLink="bacheca"
      ><img src="assets/images/logo-blu.ico" class="logo image" alt="Logo"
    /></a>
    <p class="main-font d-flex align-items-center">
      {{ pageTitle }}
      <app-section-description
        *ngIf="getDescription()"
        [descrption]="getDescription()"></app-section-description>
    </p>
    <!-- Pulsante per aprire la sidebar sui dispositivi mobili -->
    <a
      class="hover-pointer"
      routerLink="profilo-utente"
      routerLinkActive="active-link">
      <span>
        <img [src]="path" class="rounded-circle icon profile image-profile" />
      </span>
      <!--<span style="text-transform: uppercase;display: block; white-space: normal;" class="text ps-1">{{profileData.first_name + ' ' + profileData.last_name}}</span>-->
    </a>
  </div>
</header>
